<script>

export default {
    name: 'dkbr-text',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },

        text: {
            name: 'text',
            type: String,
            txtDescr: `Text`,
            default: _ => '',
        },
        display: {
            name: 'display',
            type: String,
            enum: ['none', 'inline', 'block'],
            txtDescr: `Display mode`,
            default: _ => 'block',
        },
        align: {
            name: 'align',
            type: String,
            enum: ['left', 'center', 'right', 'justify'],
            txtDescr: `Text alignment`,
            default: _ => 'left',
        },
        icon: {
            name: 'icon',
            type: String,
            txtDescr: `Icon name`,
            default: _ => '',
        },
        iconSize: {
            name: 'iconSize',
            type: Number,
            enum: [1, 2, 3, 4, 5],
            txtDescr: `Icon size`,
            default: _ => 1,
        },
        iconDir: {
            name: 'iconDir',
            type: String,
            enum: ['right', 'left'],
            txtDescr: `Icon position relative to text`,
            default: _ => 'left',
        },
    }
}
</script>

<template lang="pug">

div.dkbr-text(
    :class=`[
        'dkbr-text_align_'+align,
        'dkbr-text_display_'+display
    ]`) {{ text }}
</template>

<style lang="sass">

@import '~@/sass/root.sass'

.dkbr-text
    +padding(5px 0 1px)
    +color-font(dark)
    +font(base-bold)
    &_display_none
        display: none
    &_display_inline
        display: inline
    &_display_block
        display: block
    &_align_left
        text-align: left
    &_align_center
        text-align: center
    &_align_right
        text-align: right
    &_align_justify
        text-align: justify
</style>



// WEBPACK FOOTER //
// src/text/vue/Text.vue